<template>
  <li
    v-if="canViewVerticalNavMenuLink(item)"
    class="nav-item nav-icon"
    :class="{
      'active': isActive,
      'disabled': item.disabled
    }"
  >
    <b-link
      v-bind="linkProps"
      class="d-flex align-items-center"
    >
      <!-- imgIcon -->
      <feather-icon
        v-if="item.type === 0"
        :icon="item.icon || 'CircleIcon'"
        class="menu-icon"
      />
      <!-- <b-avatar
        v-if="item.imgIcon"
        rounded
        size="18px"
        class="mr-1"
        :src="item.imgIcon"
      /> -->
      <b-img
        v-if="item.type === 1"
        rounded
        height="18"
        width="18"
        class="mr-1 menu-icon"
        :src="item.imgIcon"
      />
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>

      <!-- <small
        v-if="item.href"
        class="text-muted"
        style="color: red"
      >
        <feather-icon
          icon="ExternalLinkIcon"
          size="15"
          class="text-muted"
        />
      </small> -->
    </b-link>

    <!-- {{ item.route.params }} -->
  </li>
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge, BImg } from 'bootstrap-vue' // BAvatar
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge,
    // BAvatar,
    BImg,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()

    return {
      isActive,
      linkProps,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuLink,

      // i18n
      t,
    }
  },

}
</script>

<style lang="scss" scoped>
.nav-icon:hover {
  .menu-icon {
    transition: transform 0.5s ease-in-out;
    animation: rotate 0.8s linear infinite;
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
      transform: rotate(360deg);
  }
}
</style>
